import { Button } from "reactstrap";
import PageLayout from "../../../components/layout/page";
import { useAddUpdate } from "../../../helper/addUpdateHook";
import { useApi } from "../../../helper/apiHook";
import { AddUpdateLocation } from "./addUpdate";
import { plus } from "../../../constant/icons";
import { columns } from "./columns";
import { DataView } from "../../../components/table/table";
import { useEffect } from "react";
import ModalView from "../../../components/modal";
export const LocationApi = (paging?:boolean, dataLoad: any = {}) => {
  return { ...useApi("/locations",paging, undefined, dataLoad) };
};
export default function Location() {
  const api = LocationApi(true);
  const AddUpdate = useAddUpdate();
  useEffect(() => {
    api.mutate();
  }, []);
  return (
    <>
      <PageLayout
        item={
          <Button
            color="secondary"
            onClick={() =>
              AddUpdate.openAddEditFrom({
                name: "",
                cityId: "",
                zoneId: "",
                description:"",
              })
            }
          >
            {plus.icon}Add New
          </Button>
        }
        View={
          <DataView
            columns={columns({
              api,
              openAddEditFrom: AddUpdate.openAddEditFrom,
            })}
            rows={api.data}
            updatePagination={api.updatePagination}
            currentPage={api.currentPage}
            rowCount={api.rowCount}
            limit={api.limit}
          />
        }
      />
      {AddUpdate.viewAddUpdate && (
        <ModalView
          modalView={AddUpdate.viewAddUpdate}
          modalName={AddUpdate.currentValue?.id ? "Edit Location" : "Add Location"}
          onModalDismiss={AddUpdate.closeAddEditFrom}
          customClass={"add-location"}
        >
          <AddUpdateLocation
            closeAddUpdate={AddUpdate.closeAddEditFrom}
            api={api}
            value={AddUpdate.currentValue}
          />
        </ModalView>
      )}
    </>
  );
}
